<template>
  <tr class="contract-notes" :class="{ collapsed: !active }">
    <td colspan="12">
      <div class="notes-wrapper">
        <div class="notes-inner-wrapper">
          <div class="notes" ref="notesBox">
            <p v-for="item in notes" :key="item.id">
              <span>{{ moment(item.createdAt).format('DD-MM-YYYY | HH:mm') }}</span>
              <span> - </span>
              <span>{{ `${item.createdBy.firstName} ${item.createdBy.lastName}` }}</span>
              <span>: </span>
              <span>{{ item.content }}</span>
            </p>
          </div>
          <div class="notes-input">
            <form @submit="addNotes">
              <text-input
                :placeholder="$t('ENTER_NOTES')"
                icon-position="right"
                v-model="notesInputVal"
                ref="notesInput"
              >
                <template v-slot:icon>
                  <font-awesome-icon class="icon right" :icon="faPaperPlane" @click="addNotes" />
                </template>
              </text-input>
              <button type="submit" cloak />
            </form>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { watch, ref } from '@vue/composition-api';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

import TextInput from '@/components/TextInput';

import paymentReminderService from '../../PaymentReminderServices';

export default {
  name: 'ContractNotes',
  components: {
    TextInput,
    FontAwesomeIcon
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    active: Boolean
  },
  setup(props) {
    const notes = ref([]);
    const notesInputVal = ref('');
    const notesInput = ref(null);
    const notesBox = ref(null);

    const fetchNotes = async () => {
      const { id } = props;
      if (!id) return;

      notes.value = await paymentReminderService.getContractNotes(id);
    };

    const addNotes = async (e) => {
      e.preventDefault();

      const { id } = props;
      if (!id) return;

      if (!notesInputVal.value) return;

      await paymentReminderService.addContractNotes(id, notesInputVal.value);
      await fetchNotes();
      notesInputVal.value = '';
    };

    watch(props, ({ active }) => {
      if (active) {
        fetchNotes();
      }
    });

    watch(notes, () => {
      if (!notesBox.value) return;

      notesBox.value.scrollTop = notesBox.value.scrollHeight;
    });

    return {
      notes,
      moment,
      faPaperPlane,
      addNotes,
      notesInputVal,
      notesInput,
      notesBox
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

.contract-notes {
  td {
    transition: all .2s ease-in-out;
    @media (max-width: 921px) {
      padding-left: 5px !important;
    }

    .notes-wrapper {
      height: 244px;
      transition: all .2s ease-in-out;
      text-align: left;

      .notes-inner-wrapper {
        position: relative;
        padding-bottom: 40px;
        height: 100%;
        width: 100%;

        .notes {
          font-size: 13px;
          height: 100%;
          width: 100%;
          overflow-y: scroll;

          p {
            margin: 0;

            span {
              color: $lavenderGrey;

              &:last-child {
                color: $independence;
              }
            }
          }
        }

        .notes-input {
          position: absolute;
          width: calc(100% + 29px);
          height: 40px;
          bottom: -10px;
          left: -14px;

          .text-input {
            width: 100%;

            input {
              border: 0;
              border-top: 1px solid $alto;
            }

            .icon {
              transition: all .2s ease-in-out;
              cursor: pointer;

              &:hover {
                color: $paradisePink;
              }
            }
          }
        }
      }
    }
  }

  &.collapsed {
    td {
      padding: 0 !important;
      border: 0 !important;

      .notes-wrapper {
        height: 0;
        overflow: hidden;
      }
    }
  }
}
</style>
